/**
 * @summary     app.jurisdiction.js
 * @description App JS jurisidction Controller
 * @version     1.0
 	> 1.0 Initial version
		- 02/15/2023 SG
 * @author      Silas Garrison
 ** EXAMPLES:
 ** NOTE:
 ** TODO:
*/

app.addFeature(
	"jurisdiction",
	function(){
		"use strict";

		var self = this,
			jurisdictionObj = null,
			jurisdictionName = null;

		/*
			Name: init
			Use: API.init()
			Args: none
			Description: initialization
		*/
		self.init = () => {
			var def = app.deferred();

			jurisdictionName = $('#target_jurisdictionName').val()??document.location.pathname.split('/')[1]??null;

			def.step(
				() => {
					if(jurisdictionName){
						app.exo.readOne(
							'jurisdictions',
							{
								path: jurisdictionName
							}
						).finished(def.next);
					}
					else {
						def.next({error:true});
					}
				}
			);

			def.step(
				function(res) {
					jurisdictionObj = (!res.error) ? res.data : null;
					def.next();
					console.log('jurisdiction initialized!');
				}
			);

			return def.begin();
		};

		self.get = (objectOrName) => {
			/*
				NOTE:
					The jurisdictionName occurs during app initialization and this could get called prior
			*/
			if((objectOrName ?? 'object' === 'name') && !jurisdictionName){
				jurisdictionName = $('#target_jurisdictionName').val()??document.location.pathname.split('/')[1]??null
			}

			return objectOrName ?? 'object' === 'name' ? jurisdictionName : JSON.clone(jurisdictionObj);
		};

		self.getAsync = () => {
			return new Promise(async function(resolve, reject) {
				if(jurisdictionObj){
					resolve(JSON.clone(jurisdictionObj));
				}
				else {
					app.exo.readOne(
						'jurisdictions',
						{
							path: self.get('name')
						}
					).finished(
						(res) => {
							resolve(res.data);
						}
					);
				}
			});
		}

		return self;
	}
);
